import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const CloseIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M18.984 6.28197L13.416 11.85L18.984 17.418L17.568 18.834L12 13.266L6.43199 18.834L5.01599 17.418L10.584 11.85L5.01599 6.28197L6.43199 4.86597L12 10.434L17.568 4.86597L18.984 6.28197Z'
        />
    ),
})

CloseIcon.displayName = 'CloseIcon'
